import React, { Component } from 'react';
import './App.css';
import UnitTable from './UnitTable';
import Select from 'react-select';
import PropTypes from 'prop-types';
import 'react-select/dist/react-select.css';
import FilterBar from './FilterBar';
import Montana135U1 from './Floorplans/Montana135U1.jpg';
import Montana135U2 from './Floorplans/Montana135U2.png';
import Montana135U3 from './Floorplans/Montana135U3.jpg';
import Montana135U4 from './Floorplans/Montana135U4.jpg';
import Montana135U5 from './Floorplans/Montana135U5.jpg';
import Montana135U7 from './Floorplans/Montana135U7.png';
import Montana135U8 from './Floorplans/Montana135U8.png';
import Montana135U9 from './Floorplans/Montana135U10.jpg';
import Montana135U10 from './Floorplans/Montana135U10.jpg';
import Montana135U11 from './Floorplans/Montana135U11.jpg';
import Montana135U12 from './Floorplans/Montana135U12.jpg';
import Montana135U14 from './Floorplans/Montana135U14.jpg';
import Montana135U15 from './Floorplans/Montana135U15.jpg';
import Montana135U16 from './Floorplans/Montana135U16.jpg';
import Montana135U18 from './Floorplans/Montana135U18.jpg';
import Montana135U19 from './Floorplans/Montana135U19.png';
import Montana435B from './Floorplans/Montana435B.jpg';
import Montana435C from './Floorplans/Montana435C.png';
import RangelyFloorPlan from './Floorplans/RangelyFloorplan.jpg';
import RangelyOneBedFloorPlan from './Floorplans/RangelyOneBedFloorPlan.jpg';
import RangelyFloorplan2 from './Floorplans/RangelyFloorplan2.jpg';




class FloorPlans extends Component {
  constructor(){
    super()
    this.state = {
      scrollHeight: document.documentElement.scrollTop,
      unitsToView: AllFloorPlans,
      activeFilters: {city: false, property: false, bedroomType: false},
      newReactKey: 1,
      cityDisabled: false,
      clearButtonDisabled: true,
      options : [
        { value: 'All', label: 'All', className: 'filterInput' },
        { value: Montana135, label: Montana135, className: 'filterInput'},
        { value: Montana435, label: Montana435, className: 'filterInput' },
        { value: Rangely8900, label: Rangely8900, className: 'filterInput' }
      ],
      cities : [
        { value: 'All', label: 'All', className: 'filterInput' },
        { value: Santa_Monica, label: 'Santa Monica', className: 'filterInput' },
        { value: West_Hollywood, label: 'West Hollywood', className: 'filterInput' }
      ],
      bedroomTypes : [
        { value: 'All', label: 'All', className: 'filterInput' },
        { value: 'Studio', label: 'Studio', className: 'filterInput' },
        { value: 'One Bedroom', label: 'One Bedroom', className: 'filterInput' },
        { value: 'Two Bedroom', label: 'Two Bedroom', className: 'filterInput' }
      ],
      ph1Filter: "Property",
      ph2Filter: "Bedroom Type",
      ph3Filter: "City"
    }

    this.update2 = this.update2.bind(this);
    this.changeCityBasedOnProperty = this.changeCityBasedOnProperty.bind(this);
    this.clearValues = this.clearValues.bind(this);

  }
  componentWillMount(){
    if(this.props.shrinkNav){this.props.shrinkNav();}
    document.body.scrollTop = document.documentElement.scrollTop = 0;
    this.props.changeClass()
  }
  changeCityBasedOnProperty(x){
    var s = this.state;
    var cityChange = {...s.changeCityBasedOnProperty}
    if(x.property === 'All'){
      cityChange.disabled = false;
      cityChange.city = 'All';
    }
    if(x.property === Montana135 || x.property === Montana435){
      cityChange.disabled = true;
      cityChange.city = 'Santa Monica';
    }
    if(x.property === Rangely8900){
      cityChange.disabled = true;
      cityChange.city = 'West Hollywood';
    }
    return cityChange;
  }
  clearValues(){
    this.setState({
      activeFilters: {city: false, property: false,
      bedroomType: false}, cityDisabled: false,
      unitsToView: AllFloorPlans,
      clearButtonDisabled: true
    })
  }

  update2(x){
    var newFilterKey = '', newFilterValue = '', newActiveFilters = this.state.activeFilters;
    //get new filter
    if (x.property) {
      newFilterKey = "property";
      newFilterValue = x.property;
    } else if (x.bedroomType) {
      newFilterKey = "bedroomType";
      newFilterValue = x.bedroomType;
    } else if (x.city) {
      newFilterKey = "city";
      newFilterValue = x.city;
    }
    //change old filter to new filter
    newActiveFilters[newFilterKey] = newFilterValue

    //get city disabled value (true/false) and city filter value ('All'/'SM'/'WH') -- city filter value may not be correct
    var cityBasedOnProperty = this.changeCityBasedOnProperty(newActiveFilters)

    //if new filter is property, then city filter value is correct. Change city filter value
    if(newFilterKey === 'property') newActiveFilters.city = cityBasedOnProperty.city;

    var newUnitsToView = AllFloorPlans.filter((y) => {
      var openSeasame = false;
      //for all keys in apartment object
      for(var key in y){
        //if key is also a filter object continue...
        if(newActiveFilters.hasOwnProperty(key) && newActiveFilters[key]){
          //if apt obj value equals the filter or if the filter is All, continue...
          if(y[key] === newActiveFilters[key] || newActiveFilters[key] === 'All'){
            //set to true -- this can get overwritten later if another value doesn't match a different filter
            openSeasame = true;
          } else {
            //apt obj doesn't pass filter
            return false;
          }
        }
      }
      return openSeasame;
    })

    this.setState({
      activeFilters: newActiveFilters,
      unitsToView: newUnitsToView,
      cityDisabled: cityBasedOnProperty.disabled,
      clearButtonDisabled: false
    })
  }

  render(){
    var t = this, s = this.state;

    return (
      <div>
        {/*<BackgroundSection reactKey={0} scrollHeight={this.state.scrollHeight} imageUrl={'url(' + Four + ')'}/>*/}
        <div id="floor-plans-section">
          <FilterBar filter1={s.options} ph1Filter={s.ph1Filter} filter2={s.bedroomTypes} ph2Filter={s.ph2Filter} filter3={s.cities} ph3Filter={s.ph3Filter} clearButtonDisabled={s.clearButtonDisabled} clearValues={t.clearValues} cityDisabled={s.cityDisabled} property={'' || s.activeFilters.property}
            bedroomType={'' || s.activeFilters.bedroomType} city={'' || s.activeFilters.city } update2={this.update2} update={this.update} label="States" searchable />
          <div className="prop-page-type">
            <div className="property-detail-container">
              <UnitTable unitArray = {this.state.unitsToView} available={false} />
            </div>
          </div>
        </div>
      </div>
    )
  }
}

const style = {
  clearButton:{
    marginTop: '47px',
    height: '27px',
    backgroundColor: 'white !important',
    borderColor: '#f7f7f7',
    fontFamily: "proxima-nova",
    fontSize: '13px'
  }
}

const Montana135 = '135 Montana Ave';
const Montana435 = '435 Montana Ave';
const Rangely8900 = '8900 Rangely Ave';
const Santa_Monica = 'Santa Monica';
const West_Hollywood = 'West Hollywood';


const AllFloorPlans = [
  {
    bedroomType: "Two Bedroom",
    bedroomText: "2 bed, 1 bath",
    unitNum: "1",
    property: Montana135,
    sqFt: "675",
    city: Santa_Monica,
    price: "$6,850",
    amenities: 'Complete Kitchen, Parking (2), Stainless Steel Appliances, Utilities, Central A/C, Washer/Dryer, Hardwood Floors, Marble/Tile Bathrooms, King/Queen Beds, Wi-fi, Smart TVs, Apple TV, Full Cable with Tivo, All-in-one Printer',
    key: 0,
    link: '',
    floorplan2d: 'url(' + Montana135U1 + ')',
    // floorplan2d: ''
  },
  {
    bedroomType: "Two Bedroom",
    bedroomText: "2 bed, 2 bath",
    unitNum: "2",
    property: Montana135,
    sqFt: "869",
    city: Santa_Monica,
    price: "$7,450 - $8,200",
    amenities: 'Complete Kitchen, Parking (2), Stainless Steel Appliances, Utilities, Central A/C, Washer/Dryer, Hardwood Floors, Marble/Tile Bathrooms, King/Queen Beds, Wi-fi, Smart TVs, Apple TV, Full Cable with Tivo, All-in-one Printer',
    key: 1,
    link: 'https://my.matterport.com/show/?m=zxe6jAfocUU',
    floorplan2d: 'url(' + Montana135U2 + ')'
  },
  {
    bedroomType: "One Bedroom",
    bedroomText: "1 Bedroom",
    unitNum: "3",
    property: Montana135,
    sqFt: "550",
    city: Santa_Monica,
    price: "$5,450 - $5,850",
    amenities: 'Complete Kitchen, Parking (1), Stainless Steel Appliances, Utilities, Central A/C, Hardwood Floors, Marble/Tile Bathrooms, Queen Bed, Wi-fi, Smart TVs, Apple TV, Full Cable with Tivo, All-in-one Printer',
    key: 2,
    link: '',
    link: 'https://my.matterport.com/show/?m=BPUxFW9NzdP',
    floorplan2d: 'url(' + Montana135U3 + ')'
  },
  {
    bedroomType: "One Bedroom",
    bedroomText: "1 Bedroom",
    unitNum: "4",
    property: Montana135,
    sqFt: "550",
    city: Santa_Monica,
    price: "$5,450 - $5,850",
    amenities: 'Complete Kitchen, Parking (2), Stainless Steel Appliances, Utilities, Central A/C, Washer/Dryer, Hardwood Floors, Marble/Tile Bathrooms, King/Queen Beds, Wi-fi, Smart TVs, Apple TV, Full Cable with Tivo, All-in-one Printer',
    key: 3,
    link: 'https://my.matterport.com/show/?m=Fo5YESARrWc',
    floorplan2d: 'url(' + Montana135U4 + ')'
  },
  {
    bedroomType: "One Bedroom",
    bedroomText: "1 bedroom",
    unitNum: "5",
    property: Montana135,
    sqFt: "503",
    city: Santa_Monica,
    price: "$4,850",
    amenities: 'Complete Kitchen, Parking (1), Stainless Steel Appliances, Utilities, Central A/C, Hardwood Floors, Marble/Tile Bathrooms, Queen Bed, Wi-fi, Smart TVs, Apple TV, Full Cable with Tivo, All-in-one Printer',
    key: 4,
    link: 'https://my.matterport.com/show/?m=wyTrHP86LfR',
    floorplan2d: 'url(' + Montana135U5 + ')'
  },
  {
    bedroomType: "Two Bedroom",
    bedroomText: "2 bed, 2 bath",
    unitNum: "6",
    property: Montana135,
    sqFt: "710",
    city: Santa_Monica,
    price: "$7,450 - $8,200",
    amenities: 'Complete Kitchen, Parking (2), Stainless Steel Appliances, Utilities, Central A/C, Washer/Dryer, Hardwood Floors, Marble/Tile Bathrooms, King/Queen Beds, Wi-fi, Smart TVs, Apple TV, Full Cable with Tivo, All-in-one Printer',
    key: 5,
    link: 'https://my.matterport.com/show/?m=UafZSRohJPY',
    floorplan2d: 'url(' + Montana135U12 + ')'
  },
  {
    bedroomType: "One Bedroom",
    bedroomText: "1 bed, 1 bath",
    unitNum: "7",
    property: Montana135,
    sqFt: "734",
    city: Santa_Monica,
    price: "$5,600 - $6,500",
    amenities: 'Complete Kitchen, Parking (2), Stainless Steel Appliances, Utilities, Central A/C, Washer/Dryer, Hardwood Floors, Marble/Tile Bathrooms, King/Queen Beds, Wi-fi, Smart TVs, Apple TV, Full Cable with Tivo, All-in-one Printer',
    key: 6,
    link: 'https://my.matterport.com/show/?m=2wD2vzvJCXx',
    floorplan2d: 'url(' + Montana135U7 + ')'
  },
  {
    bedroomType: "Two Bedroom",
    bedroomText: "2 bed, 2 bath",
    unitNum: "8",
    property: Montana135,
    sqFt: "1,054",
    city: Santa_Monica,
    price: "$9,000 - $10,000",
    amenities: 'Complete Kitchen, Parking (2), Stainless Steel Appliances, Utilities, Central A/C, Washer/Dryer, Hardwood Floors, Marble/Tile Bathrooms, King/Queen Beds, Wi-fi, Smart TVs, Apple TV, Full Cable with Tivo, All-in-one Printer',
    key: 7,
    link: 'https://my.matterport.com/show/?m=TaZzVX2yqxV',
    floorplan2d: 'url(' + Montana135U8 + ')'
  },
  {
    bedroomType: "One Bedroom",
    bedroomText: "1 bedroom",
    unitNum: "9",
    property: Montana135,
    sqFt: "510",
    city: Santa_Monica,
    price: "$5,600 - $6,500",
    amenities: 'Complete Kitchen, Parking (1), Stainless Steel Appliances, Utilities, Central A/C, Hardwood Floors, Marble/Tile Bathrooms, Queen Bed, Wi-fi, Smart TVs, Apple TV, Full Cable with Tivo, All-in-one Printer',
    key: 8,
    link: 'https://my.matterport.com/show/?m=DAQsSyGPiKx&play=1',
    floorplan2d: 'url(' + Montana135U9 + ')'
  },
  {
    bedroomType: "One Bedroom",
    bedroomText: "1 bedroom",
    unitNum: "10",
    property: Montana135,
    sqFt: "510",
    city: Santa_Monica,
    price: "$5,450 - $5,850",
    amenities: 'Complete Kitchen, Parking (1), Stainless Steel Appliances, Utilities, Central A/C, Hardwood Floors, Marble/Tile Bathrooms, Queen Bed, Wi-fi, Smart TVs, Apple TV, Full Cable with Tivo, All-in-one Printer',
    key: 9,
    link: 'https://my.matterport.com/show/?m=RTJTS1HFgy5&',
    floorplan2d: 'url(' + Montana135U10 + ')'
  },
  {
    bedroomType: "One Bedroom",
    bedroomText: "1 bedroom",
    unitNum: "11",
    property: Montana135,
    sqFt: "400",
    city: Santa_Monica,
    price: "$5,450 - $5,850",
    amenities: 'Complete Kitchen, Parking (1), Stainless Steel Appliances, Utilities, Central A/C, Hardwood Floors, Marble/Tile Bathrooms, Queen Bed, Wi-fi, Smart TVs, Apple TV, Full Cable with Tivo, All-in-one Printer',
    key: 10,
    link: 'https://my.matterport.com/show/?m=Xz7CSCLrvg3&play=1',
    floorplan2d: 'url(' + Montana135U11 + ')'
  },
  {
    bedroomType: "Two Bedroom",
    bedroomText: "2 bed, 2 bath",
    unitNum: "12",
    property: Montana135,
    sqFt: "705",
    city: Santa_Monica,
    price: "$7,450 - $8,200",
    amenities: 'Complete Kitchen, Parking (2), Stainless Steel Appliances, Utilities, Central A/C, Washer/Dryer, Hardwood Floors, Marble/Tile Bathrooms, King/Queen Beds, Wi-fi, Smart TVs, Apple TV, Full Cable with Tivo, All-in-one Printer',
    key: 11,
    link: 'https://my.matterport.com/show/?m=CL7NjgKTM6C',
    floorplan2d: 'url(' + Montana135U12 + ')'
  },
  {
    bedroomType: "One Bedroom",
    bedroomText: "1 bedroom",
    unitNum: "14",
    property: Montana135,
    sqFt: "400",
    city: Santa_Monica,
    price: "$4,850",
    amenities: 'Complete Kitchen, Parking (1), Stainless Steel Appliances, Utilities, Central A/C, Hardwood Floors, Marble/Tile Bathrooms, Queen Bed, Wi-fi, Smart TVs, Apple TV, Full Cable with Tivo, All-in-one Printer',
    key: 12,
    link: 'https://my.matterport.com/show/?m=ZUakNrttejC',
    floorplan2d: 'url(' + Montana135U14 + ')'
  },
  {
    bedroomType: "Studio",
    bedroomText: "Studio",
    unitNum: "15",
    property: Montana135,
    sqFt: "361",
    city: Santa_Monica,
    price: "$4,500",
    amenities: 'Complete Kitchen, Parking (1), Stainless Steel Appliances, Utilities, Central A/C, Hardwood Floors, Marble/Tile Bathrooms, Queen Bed, Wi-fi, Smart TVs, Apple TV, Full Cable with Tivo, All-in-one Printer',
    key: 13,
    link: 'https://my.matterport.com/show/?m=yXFAEP2hoYi',
    floorplan2d: 'url(' + Montana135U15 + ')'
  },
  {
    bedroomType: "Two Bedroom",
    bedroomText: "2 bed, 1 bath",
    unitNum: "16",
    property: Montana135,
    sqFt: "724",
    city: Santa_Monica,
    price: "$6,850",
    amenities: 'Complete Kitchen, Parking (1), Stainless Steel Appliances, Utilities, Central A/C, Hardwood Floors, Marble/Tile Bathrooms, Queen Bed, Wi-fi, Smart TVs, Apple TV, Full Cable with Tivo, All-in-one Printer',
    key: 14,
    link: 'https://my.matterport.com/show/?m=CVTYQNeb8Ds&play=1',
    floorplan2d: 'url(' + Montana135U16 + ')'
  },
  {
    bedroomType: "One Bedroom",
    bedroomText: "1 bedroom",
    unitNum: "18",
    property: Montana135,
    sqFt: "495",
    city: Santa_Monica,
    price: "$5,450 - $5,850",
    amenities: 'Complete Kitchen, Parking (1), Stainless Steel Appliances, Utilities, Central A/C, Hardwood Floors, Marble/Tile Bathrooms, Queen Bed, Wi-fi, Smart TVs, Apple TV, Full Cable with Tivo, All-in-one Printer',
    key: 15,
    link: 'https://my.matterport.com/show/?m=NwUobjeJP2P&play=1',
    floorplan2d: 'url(' + Montana135U18 + ')'
  },
  {
    bedroomType: "One Bedroom",
    bedroomText: "1 bedroom",
    unitNum: "19",
    property: Montana135,
    sqFt: "560",
    city: Santa_Monica,
    price: "$5,450 - $5,850",
    amenities: 'Complete Kitchen, Parking (1), Stainless Steel Appliances, Utilities, Central A/C, Hardwood Floors, Marble/Tile Bathrooms, Queen Bed, Wi-fi, Smart TVs, Apple TV, Full Cable with Tivo, All-in-one Printer',
    key: 16,
    link: 'https://my.matterport.com/show/?m=gxGyuzFx2zr',
    floorplan2d: 'url(' + Montana135U19 + ')'
  },
  {
    bedroomType: "Two Bedroom",
    bedroomText: "2 bed, 2 bath",
    unitNum: "B",
    property: Montana435,
    sqFt: "1,500",
    city: Santa_Monica,
    price: "$9,000 - $10,500",
    amenities: 'Complete Kitchen, Parking (2), Stainless Steel Appliances, Utilities, Central A/C, Washer/Dryer, Office, Hardwood Floors, Marble/Tile Bathrooms, King/Queen Beds, Wi-fi, Smart TVs, Apple TV, Full Cable with Tivo, fireplace, All-in-one Printer',
    key: 17,
    link: 'https://my.matterport.com/show/?m=E3oE8FjXzD1',
    floorplan2d: 'url(' + Montana435B + ')'
  },
  {
    bedroomType: "Two Bedroom",
    bedroomText: "2 bed, 2 bath",
    unitNum: "C",
    property: Montana435,
    sqFt: "1,500",
    city: Santa_Monica,
    price: "$9,000 - $10,500",
    amenities: 'Complete Kitchen, Parking (2), Stainless Steel Appliances, Utilities, Central A/C, Washer/Dryer, Office, Hardwood Floors, Marble/Tile Bathrooms, King/Queen Beds, Wi-fi, Smart TVs, Apple TV, Full Cable with Tivo, fireplace, All-in-one Printer',
    key: 18,
    link: 'https://my.matterport.com/show/?m=1d2X3wqoUoF',
    floorplan2d: 'url(' + Montana435C + ')'
  },
  {
    bedroomType: "Two Bedroom",
    bedroomText: "2 bed, 2.5 bath",
    unitNum: "8900 Rangely",
    property: Rangely8900,
    sqFt: "1,470",
    city: West_Hollywood,
    price: "$9,000 - $10,500",
    amenities: 'Complete Kitchen, Parking (2), Stainless Steel Appliances, Utilities, Central A/C, Washer/Dryer, Office, Hardwood Floors, Marble/Tile Bathrooms, King/Queen Beds, Wi-fi, Smart TVs, Apple TV, Full Cable with Tivo, fireplace, All-in-one Printer',
    key: 19,
    link: 'https://my.matterport.com/show/?m=da4bXVZuQBz',
    floorplan2d: 'url(' + RangelyFloorPlan + ')'
  },
  {
    bedroomType: "Two Bedroom",
    bedroomText: "2 bed, 2.5 bath",
    unitNum: "8902 Rangely",
    property: Rangely8900,
    sqFt: "1,315",
    city: West_Hollywood,
    price: "$9,000 - $10,500",
    amenities: 'Complete Kitchen, Parking (2), Stainless Steel Appliances, Utilities, Central A/C, Washer/Dryer, Office, Hardwood Floors, Marble/Tile Bathrooms, King/Queen Beds, Wi-fi, Smart TVs, Apple TV, Full Cable with Tivo, All-in-one Printer',
    key: 20,
    link: 'https://my.matterport.com/show/?m=sTZ8HHrFy5C',
    floorplan2d: 'url(' + RangelyFloorplan2 + ')'
  },
  {
    bedroomType: "One Bedroom",
    bedroomText: "1 bedroom",
    unitNum: "8902 1/2 Rangely",
    property: Rangely8900,
    sqFt: "399",
    city: West_Hollywood,
    price: "$4,950",
    amenities: 'Complete Kitchen, Parking (1), Stainless Steel Appliances, Utilities, Central A/C, Washer/Dryer, Hardwood Floors, Marble/Tile Bathrooms, Queen Bed, Wi-fi, Smart TVs, Apple TV, Sonos, Full Cable with Tivo, All-in-one Printer',
    key: 21,
    link: 'https://my.matterport.com/show/?m=fFwv9LmBUUc',
    floorplan2d: 'url(' + RangelyOneBedFloorPlan + ')'
  }
  
]



export default FloorPlans;



// WEBPACK FOOTER //
// ./src/FloorPlans.js